<template>
  <div class="flight-seat-container">
    <div class="info-part part">
      <h4>乘机人信息</h4>
      <flight-info :passengerData="passengerData" :seatItem="seatItem"></flight-info>
    </div>
    <div class="seat-part part">
      <h4>座位信息</h4>
      <a-spin class="seat-loading" v-if="seatData.length === 0"></a-spin>
      <div
        class="seat-bg clearfix"
        :class="[airplaneData.airplaneType === '330' ? 'airplane-type-330' : 'airplane-type-normal']"
        v-else
      >
        <div class="seat-head">
          <p v-if="airplaneData.airplaneTyp && airplaneData.airplaneClass">{{airplaneData.airplaneType}} - {{airplaneData.airplaneClass}}</p>
        </div>
        <div class="seat-body">
          <div class="seat-body-in clearfix">
            <seat-row :seatData="seatData" @selectSeat="onSelectSeat"></seat-row>
          </div>
        </div>
        <div class="seat-tail"></div>
        <span class="wing wing-top"></span>
        <span class="wing wing-bottom"></span>
      </div>
      <div class="seat-desc">
        <ul class="seat-desc-list clearfix">
          <!-- <li>
            <div class="seat-desc-item seat1">
              <p class="seat-title">最舒适的座位</p>
              <p>座位空间大，舒心于旅行</p>
            </div>
          </li>
          <li>
            <div class="seat-desc-item seat2">
              <p class="seat-title">最欢迎的座位</p>
              <p>优先享服务，旅程较平稳</p>
            </div>
          </li> -->
          <li>
            <div class="seat-desc-item seat3">
              <p class="seat-title">当前可选座位</p>
              <p>可选择座位</p>
            </div>
          </li>
          <li>
            <div class="seat-desc-item seat4">
              <p class="seat-title">当前座位已被选择</p>
              <p>座位已被选，无法接受选座</p>
            </div>
          </li>
          <li>
            <div class="seat-desc-item seat5">
              <p class="seat-title">不能选座</p>
              <p>飞机配载限制，无法接受选座</p>
            </div>
          </li>
          <li>
            <div class="seat-desc-item seat6">
              <p class="seat-title">您当前选中的座位</p>
              <p>旅客当前已选中的座位</p>
            </div>
          </li>
          <li>
            <div class="seat-desc-item seat7">
              <p class="seat-title">同行人员已选座位</p>
              <p>同行程旅客当前已选中的座位</p>
            </div>
          </li>
          <li>
            <div class="seat-desc-item seat8">
              <p class="seat-title">付费座位</p>
              <p>付费座位</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="tip-part part" v-if="contentData.tipContent">
      <div>
        <p>温馨提示：</p>
        <p v-html="contentData.tipContent"></p>
      </div>
    </div>
    <div class="action-part part">
      <div class="agreement" v-if="agreeListWithFilter?.length > 0">
        <AgreementTrack
          :checked="agreement"
          :cmsId="contentData.agreeListModuleId"
          description='选座'
          pageName='seat_book'
          @change="e => agreement = e"
        >
          我已阅读，理解并同意
          <a v-for="(item, index) in agreeListWithFilter" :key="item.title" target="_blank" :href="item.url">{{ item.name }}{{ index === (agreeListWithFilter.length - 1) ? '' : '，'}}</a>
        </AgreementTrack>
      </div>
      <div class="checkin-operation clearfix">
        <a-button type="primary" class="submit-btn f-left" size="large" @click="onSureSeat" :disabled="!(seatItem)">确认选座</a-button>
        <a-button class="cancel-btn f-right" size="large" @click="onCancelSeat">取消选座</a-button>
      </div>
    </div>
  </div>

</template>
<script>
import seatRow from './seat-row'
import flightInfo from './flight-info'
import { filterRegion } from '@/assets/js/util'
import AgreementTrack from '@/components/agreement-track'

export default {
  props: {
    seatData: Array,
    airplaneData: Object,
    passengerData: Object,
    contentData: Object,
    seatItem: Object,
    ifInternational: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      agreement: false
    }
  },
  computed: {
    agreeListWithFilter () {
      const { ifInternational, contentData } = this
      const agreeList = contentData.agreements
      const agreeListWithFilter = agreeList?.filter(item => {
        // 航班地区
        const currentRegion = filterRegion(item, ifInternational)
        return currentRegion
      }) ?? []
      return agreeListWithFilter
    }
  },
  methods: {
    onSelectSeat (seatItem, method) {
      this.$emit('updateSeat', seatItem, method)
    },
    onCancelSeat () {
      this.$emit('cancelSeat')
      this.agreement = false
    },
    onSureSeat () {
      const { agreement } = this
      if (!agreement) {
        const { agreements } = this.contentData
        const titles = agreements.map(item => { return item.name })
        this.$error({
          title: '温馨提示',
          content: `请确认您已阅读并接受${titles}`
        })
        return false
      }
      this.$modal.confirm({
        title: '温馨提示',
        content: '如遇航班取消、机型或座位布局变更等特殊情况，座位号可能会有所变动，请听从现场工作人员的安排。',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.$emit('sureSeat')
          this.agreement = false
        }
      })
    }
  },
  components: {
    seatRow,
    flightInfo,
    AgreementTrack
  }
}
</script>
<style lang="less">
.flight-seat-container {
  h4 {
    margin-bottom: 10px;
    margin-left: 10px;
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
  }
  .part:not(:first-child) {
    margin-top: 10px;
  }
  .seat-part {
    .seat-loading {
      margin: 0 auto;
      width: 100%;
      height: 160px;
      line-height: 160px;
    }
    .seat-bg {
      position: relative;
      display: flex;
      justify-content: center;
    }
    .seat-head {
      p {
        transform: rotate(-90deg);
        text-align: right;
        margin-top: 80px;
        margin-left: 90px;
        font-size: 14px;
      }
    }
    .seat-body {
      float: left;
      min-width: 230px;
      max-width: 900px;
      padding: 10px 25px;
      border-top: 1px solid #808080;
      border-bottom: 1px solid #808080;
      position: relative;
    }
    .wing {
      display: block;
      position: absolute;
      width: 125px;
      height: 11px;
      left: 50%;
    }
    .wing-top {
      background-image: url(../img/wing_top.png);
      top: -10px;
    }
    .wing-bottom {
      background-image: url(../img/wing_bottom.png);
      bottom: -10px;
    }
    .airplane-type-normal {
      .seat-bg {
        margin-top: 55px;
      }
      .seat-head {
        float: left;
        width: 164px;
        min-height: 178px;
        background-image: url(../img/head.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .seat-tail {
        float: left;
        width: 97px;
        min-height: 178px;
        background-image: url(../img/tail.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;

      }
      .seat-body {
        min-height: 178px;
      }
    }
    .airplane-type-330 {
      .seat-head {
        float: left;
        width: 228px;
        height: 250px;
        background-image: url(../img/head_330.png);
        p {
          margin-top: 140px;
          margin-left: 120px;
        }
      }
      .seat-tail {
        float: left;
        width: 135px;
        height: 250px;
        background-image: url(../img/tail_330.png);
      }
      .seat-body {
        height: 250px;
        padding: 5px 20px;
        overflow-x: scroll;
        overflow-y: hidden;
      }
      .seat-body-in {
        width: 980px;
      }
      .wing {
        left: 32%;
      }
    }

    .seat-desc {
      padding-top: 50px;
    }
    .seat-desc-list {
      width: 1100px;
      margin: 0 auto;
      text-align: center;
      li {
        display: inline-block;
        margin-right: 20px;
      }
      .seat-desc-item {
        display: inline-block;
        padding-left: 28px;
        background-position: left center;
        background-repeat: no-repeat;
        p {
          font-size: 12px;
          line-height: 18px;
          color: #808080;
        }
        p.seat-title {
          font-weight: bold;
        }
      }
      .seat-desc-item.seat1 {
        background-image: url(../img/seat1.png);
      }
      .seat-desc-item.seat2 {
        background-image: url(../img/seat2.png);
      }
      .seat-desc-item.seat3 {
        background-image: url(../img/seat3.png);
      }
      .seat-desc-item.seat4 {
        background-image: url(../img/seat4.png);
      }
      .seat-desc-item.seat5 {
        background-image: url(../img/seat5.png);
      }
      .seat-desc-item.seat6 {
        background-image: url(../img/seat6.png);
      }
      .seat-desc-item.seat7 {
        background-image: url(../img/seat6.png);
        opacity: .7;
      }
      .seat-desc-item.seat8 {
        background-image: url(../img/seat8.png);
      }
    }
  }
  .tip-part {
    > div {
      width: 80%;
      margin: 0 auto;
      p {
        color: @primary-color
      }
    }
  }
  .action-part {
    text-align: center;
    .checkin-operation {
      width: 80%;
      margin: 0 auto;
      padding-top: 10px;
      .submit-btn,.cancel-btn {
        width: 48%;
        margin-top: 10px;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .flight-info-container {
    width: 96%;
    border: 1px solid #bfbfbf;
    margin: 0 auto;
    overflow-x: scroll;
  }
  .flight-seat-container {
    .seat-part {
      .seat-desc-list {
        width: 98%;
        margin: 0 auto;
        li {
          float: left;
          width: 46%;
          height: 55px;
          margin: 0 2%;
          text-align: left;
        }
        .seat-desc-item {
          background-position: left top;
        }
      }
      .seat-head,
      .seat-tail {
        display: none;
      }
      .seat-bg {
        margin-top: 30px;
      }
      .seat-body {
        // width: 300px;
        height: auto;
        margin: 0 auto;
        float: none;
        padding: 10px 20px;
        border-top: 0;
        border-bottom: 0;
        border-left: 1px solid #808080;
        border-right: 1px solid #808080;
      }
      .airplane-type-normal .seat-body {
        height: auto;
      }
      .airplane-type-330 .seat-body {
        width: 325px;
        padding: 10px 15px;
        height: auto;
        .seat-body-in {
          width: auto;
        }
      }
      .wing {
        display: none;
      }
    }
  }
}

.f-left {
  float: left;
}
.f-right {
  float: right;
}

</style>
